import React from "react";
import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

import { Tooltip } from "../Tooltip";

const useStyles = makeStyles()((theme: Theme) => ({
    explained: {
        textDecorationLine: "underline",
        textDecorationStyle: "dotted",
        textDecorationColor: theme.palette.emteria.text.secondary,
        textUnderlineOffset: 4,
    },
    tooltipText: {
        whiteSpace: "pre-line",
    },
}));

type HeaderLabelProps = {
    children: React.ReactNode;
    /**
     * Explains a header that is not self-explanatory. The label is then underlined with dots, and the text shows
     * on hover and on keyboard focus.
     */
    tooltip?: string;
};

/**
 * A column header's label. For a TanStack column, set `meta.headerTooltip` instead of rendering this yourself.
 */
export const HeaderLabel = ({ children, tooltip }: HeaderLabelProps) => {
    const { classes } = useStyles();

    if (!tooltip) {
        return children;
    }

    // `describeChild` keeps the label as the header's accessible name; by default MUI would replace it with the tooltip.
    return (
        <Tooltip title={<span className={classes.tooltipText}>{tooltip}</span>} describeChild disableChildrenWrapper>
            <span className={classes.explained} tabIndex={0}>
                {children}
            </span>
        </Tooltip>
    );
};
